import EmptyClaimIcon from './ic__empty-claim.svg';

export { EmptyClaimIcon };
